import React from 'react';
import { Box, Chip } from '@mui/material';

function SuggestionChips({ suggestions, onSuggestionClick }) {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, ml: 4.5, mb: 1.5 }}>
      {suggestions.map((suggestion, index) => (
        <Chip
          key={index}
          label={suggestion}
          variant="outlined"
          size="small"
          clickable
          onClick={() => onSuggestionClick(suggestion)}
          sx={{
            borderColor: '#e2e8f0',
            color: '#1a365d',
            fontSize: '0.775rem',
            height: 'auto',
            '& .MuiChip-label': {
              whiteSpace: 'normal',
              py: 0.75,
              px: 1,
            },
            '&:hover': {
              bgcolor: '#ebf4ff',
              borderColor: '#3182ce',
            },
          }}
        />
      ))}
    </Box>
  );
}

export default SuggestionChips;
